export default {
    FROM: {
        TIMETABLES: 'exam-timetables',
        APPLICATIONS: 'exam-applications',
        APPLICANT_EXAMS: 'applicant-exams',
        RECOGNITION: 'exam-recognition',
    },
};
